import type { HTMLAttributes } from 'react';
import { cn } from './cn.js';

type Variant = 'default' | 'elevated' | 'glass' | 'outline';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
  interactive?: boolean;
}

const variants: Record<Variant, string> = {
  default: 'bg-surface-2 border border-line',
  elevated: 'bg-surface-3 border border-line shadow-card',
  glass: 'glass border border-line',
  outline: 'bg-transparent border border-line',
};

export function Card({
  variant = 'default',
  interactive,
  className,
  ...rest
}: CardProps) {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-2xl',
        variants[variant],
        interactive &&
          'transition-all duration-150 active:scale-[0.985] hover:border-gold/20 cursor-pointer',
        className,
      )}
    />
  );
}

export function CardHeader({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div {...rest} className={cn('px-5 pt-5 pb-3', className)} />;
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div {...rest} className={cn('px-5 pb-5', className)} />;
}

export function CardTitle({ className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2
      {...rest}
      className={cn('text-base font-semibold tracking-tight text-text', className)}
    />
  );
}
